import * as NoteField from './field';

import { BaseItem, NullablePartial } from '../common';

export enum Kind {
  Content = 'CONTENT',
  Title = 'TITLE',
}

export interface BaseValues {
  noteTranscriptSegmentId: string;
  value: string;
  noteFieldId: string | null;
  section: NoteField.Section;
  subsection: string | null;
  name: string;
  rank: number;
  kind: Kind;
}

export type CreateValues = NullablePartial<BaseValues>;
export type UpdateValues = Partial<BaseValues>;

export interface NoteTranscriptSegmentFieldMap extends BaseItem, BaseValues {}
